import { useViewSlice } from "@store/slices/view";

export const useDebugBorder = (color?: string, width?: number, transparent?: boolean) => {
    const { showExtendedView } = useViewSlice();

    return showExtendedView ? `${width ?? 1}px ${transparent ? "transparent" : "solid"} ${color ?? "red"}` : undefined;
};
